import React, { FC } from 'react';
import { Hyperlink } from '../Hyperlink';
import styles from './animated_link.module.scss';
import { MaterialIcon } from '../material-icon/MaterialIcon';

type AnchorProps = React.HTMLProps<HTMLAnchorElement>;
interface Props extends AnchorProps {
  component?: React.ReactType;
  source?: string;
}

export const AnimatedLink: FC<Props> = ({
  children,
  component: Component = Hyperlink,
  ...rest
}) => (
  <Component {...rest} className={styles.container}>
    <span className={styles.title}>{children}</span>
    <span className={styles.icon}>
      <MaterialIcon name="arrow_forward" />
    </span>
  </Component>
);
